import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import ReportingFilters from 'content-management-details-lib/components/reporting/ReportingFilters';
import SmartContentChart from 'content-management-details-lib/components/reporting/smartContent/SmartContentChart';
import SmartContentTable from 'content-management-details-lib/components/reporting/smartContent/SmartContentTable';
import useSmartContentActivities from '../hooks/useSmartContentActivities';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SmartContentNoData = () => {
  return /*#__PURE__*/_jsx(EmptyState, {
    primaryContent: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.smartContentNoData.body"
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "target",
      width: 200
    }),
    secondaryContentWidth: 200,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.smartContentNoData.title"
    })
  });
};
const SmartContentCharts = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ReportingFilters, {}), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "500",
      children: [/*#__PURE__*/_jsx(SmartContentChart, {}), /*#__PURE__*/_jsx(SmartContentTable, {
        metricsToDisplay: ['rawViews', 'submissionsPerPageview', 'contactsPerPageview', 'customersPerPageview', 'pageBounceRate', 'timePerPageview', 'exitsPerPageview']
      })]
    })]
  });
};
const SmartContentContainer = () => {
  const {
    hasActivities,
    smartContentActivitiesRequestLoading,
    smartContentActivitiesRequestError
  } = useSmartContentActivities();
  if (smartContentActivitiesRequestLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }
  if (!smartContentActivitiesRequestLoading && !smartContentActivitiesRequestError && !hasActivities) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "SMART_CONTENT_LOADED_NO_DATA",
      children: /*#__PURE__*/_jsx(SmartContentNoData, {})
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "SMART_CONTENT_LOADED",
    children: /*#__PURE__*/_jsx(SmartContentCharts, {})
  });
};
export default SmartContentContainer;